<template>
  <v-container>
    <v-container v-show="showAdd" class="py-0 px-0 m-0">
      <span>Here you can add a new filter to the data table.</span>
      <v-select
        v-model="newFilter.field"
        :items="filterOptions"
        label="Column"
        item-text="text"
        item-value="key"
      />
      <v-select
        v-if="newFilter.field"
        v-model="newFilter.operator"
        :items="validOperators(newFilter.field)"
        label="Filter"
        item-text="text"
        item-value="key"
      />
      <v-text-field v-if="newFilter.operator && newFilter.field && filterOptions.find(f => f.key === newFilter.field).type !== 'enum'" v-model="newFilter.value" label="Value" />
      <v-select v-if="newFilter.operator && newFilter.field && filterOptions.find(f => f.key === newFilter.field).type === 'enum'" v-model="newFilter.value" label="Value" :items="filterOptions.find(f => f.key === newFilter.field).options" />
      <v-layout>
        <v-btn color="primary" class="mx-0 px0" @click="exitAdd()" v-text="'Cancel'" />
        <v-spacer />
        <v-btn v-if="newFilter.value !== null && newFilter.value !== undefined" color="secondary" class="mx-0 px-0" @click="addFilter()" v-text="'Add'" />
      </v-layout>
    </v-container>
    <v-container v-show="!showAdd" class="py-0 px-0 m-0">
      <v-layout justify-center row>
        <v-flex>
          <v-flex v-if="!activeFilters.length" text-center class="py-2">
            There are currently no active filters
          </v-flex>
          <v-list v-if="activeFilters.length" subheader>
            <v-subheader>Current Filters</v-subheader>
            <v-list-item v-for="(filter, index) in activeFilters" :key="index" row style="width: 100%" justify-between>
              <v-list-item-content>{{ filter.text }}</v-list-item-content>
              <v-list-item-action>
                <v-btn icon class="mx-0" @click.stop="toggleFilterDisabled(filter)">
                  <v-icon color="grey darken-2">
                    {{ filter.disabled ? 'visibility_off' : 'visibility' }}
                  </v-icon>
                </v-btn>
              </v-list-item-action>
              <v-list-item-action>
                <v-btn icon class="mx-0" @click.stop="removeFilter(filter)">
                  <v-icon color="grey darken-2">
                    delete
                  </v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-spacer />
        <v-btn fab color="secondary" @click.stop="showAdd = true">
          <v-icon dark>
            add
          </v-icon>
        </v-btn>
      </v-layout>
    </v-container>
  </v-container>
</template>

<script>
export default {
  props: {
    filterOptions: {
      type: Array,
      required: true
    },
    activeFilters: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      newFilter: {},
      showAdd: false
    }
  },
  methods: {
    validOperators(key) {
      const filterType = this.filterOptions.find(f => f.key === key).type
      return getValidOperators(filterType)
    },
    isEnum(key) {
      return this.filterOptions.find(f => f.key === key).type === 'enum'
    },
    exitAdd() {
      this.newFilter = {}
      this.showAdd = false
    },
    addFilter() {
      const fieldName = this.filterOptions.find(f => f.key === this.newFilter.field).text
      const operatorName = getOperatorTitle(this.newFilter.operator)
      this.newFilter.text = `'${fieldName}' ${operatorName} '${this.newFilter.value}'`
      this.newFilter.disabled = false

      this.$emit('addfilter', this.newFilter)
      this.exitAdd()
    },
    toggleFilterDisabled(filter) {
      this.$emit('filterstatus', filter)
    },
    removeFilter(filter) {
      this.$emit('removefilter', filter)
    }
  }
}

export function getValidOperators(type) {
  return type === 'string' ? stringOperators : type === 'enum' ? enumOperators : operators
}

export function getOperatorTitle(key) {
  return operators.find(o => o.key === key).text
}

const operators = [
  { text: 'Equals', key: 'eq' },
  { text: 'Not Equals', key: 'ne' },
  { text: 'Contains', key: 'lk' },
  { text: 'Greater than', key: 'gt' },
  { text: 'Greater than or equal to', key: 'gte' },
  { text: 'Less than', key: 'lt' },
  { text: 'Less than or equal to', key: 'lte' }
]

const stringOperators = [
  { text: 'Equals', key: 'eq' },
  { text: 'Not Equals', key: 'ne' },
  { text: 'Contains', key: 'lk' }
]

const enumOperators = [
  { text: 'Equals', key: 'eq' },
  { text: 'Not Equals', key: 'ne' }
]

</script>
